__turbopack_context__.v({
  "root": "PremiumOrganizerBadgeIcon-module-scss-module__IRbHiW__root",
  "svg": "PremiumOrganizerBadgeIcon-module-scss-module__IRbHiW__svg",
});
